<template>
  <div
    v-on-click-outside="handleClickOutside"
    class="dropdown"
    :class="open ? 'dropdown-open' : ''"
    @click="changeOpenState"
  >
    <slot name="trigger">
      <button
        class="dropdown-trigger"
        type="button"
      >
        <span>{{ triggerText }}</span>

        <FontAwesomeIcon :icon="icon" />
      </button>
    </slot>

    <div
      v-show="open"
      :class="contentWidth"
      class="dropdown-content"
    >
      <slot>
        <template
          v-for="(item, index) in items"
          :key="index"
        >
          <AppDropdownItem
            :to="item.to"
            @click="open = false"
          >
            {{ item.label }}
          </AppDropdownItem>
        </template>
      </slot>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { vOnClickOutside } from '@vueuse/components';
import { AppDropdownItem } from '@/components/app';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faChevronDown } from '@fortawesome/sharp-regular-svg-icons';

const props = defineProps({
  triggerText: {
    type: String,
    default: 'Actions',
  },
  placement: {
    type: String,
    default: 'bottom-start',
  },
  items: {
    type: Array,
    default: () => [],
  },
  icon: {
    type: Object,
    default: () => faChevronDown,
  },
  contentWidth: {
    type: String,
    default: '',
  },
  disabled: Boolean,
});

const open = ref(false);

const handleClickOutside = () => {
  if (open.value) {
    open.value = false;
  }
};

const changeOpenState = () => {
  if (!props.disabled) {
    open.value = !open.value;
  }
};

</script>
